import { cn } from "@/lib/utils";

const SectionCardTitle = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <h1
      className={cn(
        "text-[25px] lg:text-[42px] lg:w-[700px] text-start font-bold leading-tight",
        className
      )}
    >
      {children}
    </h1>
  );
};

export default SectionCardTitle;
